import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  submit(event) {
    if (this.commitAfterFlush) {
      this.commitAfterFlush = false
      return
    }

    event.preventDefault()

    const submitter = event.submitter

    this.flushRowEdits()
      .then(() => {
        // Une tâche, pas une micro-tâche : après un vrai clic, les micro-tâches passent entre deux
        // écouteurs, donc pendant que ce `submit` se propage encore. Le navigateur ignore alors
        // sans bruit le `requestSubmit` (« firing submission events ») : rien ne partait.
        setTimeout(() => {
          if (!this.element.isConnected) return

          this.commitAfterFlush = true
          this.element.requestSubmit(submitter?.isConnected ? submitter : null)
        }, 0)
      })
      .catch(() => {})
  }

  flushRowEdits() {
    const preview = this.element.closest("turbo-frame") || document
    const editables = preview.querySelectorAll('[data-controller~="employment-import-preview-field"]')

    return Promise.all(
      Array.from(editables).map((element) => {
        const controller = this.application.getControllerForElementAndIdentifier(
          element,
          "employment-import-preview-field"
        )

        return controller?.flushPendingChanges?.() ?? Promise.resolve()
      })
    )
  }
}
